import { useStore } from '@nanostores/react'
import { Trash } from 'lucide-react'

import { Button } from '~/elements/Button'
import { ConfirmDialog } from '~/elements/ConfirmDialog'
import { Divider } from '~/elements/Divider'
import {
  useBatchDeleteRecordsMutation,
  useBatchDeleteRelatedRecordsMutation
} from '~/features/records/hooks/useRecordMutations'

import { $hasRecordsSelection, $selectionLength } from '../stores/actionbar'
import {
  $hasRelatedRecordsSelection,
  $selectionRelatedLength
} from '~/features/records/stores/related-actionbar.ts'

function DeleteSelected({ view = 'main' }: { view?: 'related' | 'main' }) {
  const batchDeleteMutation = useBatchDeleteRecordsMutation()
  const batchDeleteRelatedMutation = useBatchDeleteRelatedRecordsMutation()

  const mutation = view === 'main' ? batchDeleteMutation : batchDeleteRelatedMutation

  return (
    <ConfirmDialog
      trigger={
        <Button className="rounded-none text-danger hover:bg-danger/20" size="small" variant="inverse">
          <Trash />
          Delete
        </Button>
      }
      handler={async () => {
        mutation.mutate()
      }}
      loading={mutation.isPending}
      title="Delete selected records?"
    />
  )
}

export function RecordsBatchActionsBar({ view = 'main' }: { view?: 'related' | 'main' }) {
  const hasSelection = useStore($hasRecordsSelection)
  const selectionLength = useStore($selectionLength)

  const hasRelatedSelection = useStore($hasRelatedRecordsSelection)
  const selectionRelatedLength = useStore($selectionRelatedLength)

  const hidden = view === 'main' ? !hasSelection : !hasRelatedSelection

  if (hidden) {
    return null
  }

  return (
    <div className="fixed bottom-24 left-1/2 z-10 flex -translate-x-1/2 animate-in items-center overflow-clip rounded-2xl border-content/30 bg-content text-fill shadow-2xl ring">
      <span className="px-3 font-mono text-sm font-medium text-fill/70">
        {selectionLength || selectionRelatedLength} selected
      </span>
      <Divider className="bg-fill2/30" vertical />
      <DeleteSelected view={view} />
    </div>
  )
}
